import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ElevatorHero from './components/ElevatorHero';
import ElevatorIntro from './components/ElevatorIntro';
import ElevatorServices from './components/ElevatorServices';
import ElevatorTypes from './components/ElevatorTypes';
import TechAndSafety from './components/TechAndSafety';
import ExpandableSolutions from './components/ExpandableSolutions';
import ElevatorCTA from './components/ElevatorCTA';

const ElevatorSolutions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Elevator Solutions | Advanced Vertical Transportation | VASTECH</title>
        <meta
          name="description"
          content="VASTECH provides comprehensive elevator solutions designed for smooth movement, operational reliability, and advanced safety standards in modern buildings."
        />
        <meta
          name="keywords"
          content="elevator solutions, vertical transportation, elevator installation, elevator modernization, preventive maintenance, passenger elevators, freight elevators, UAE elevators"
        />
        <meta property="og:title" content="Elevator Solutions | VASTECH" />
        <meta
          property="og:description"
          content="Precision-engineered elevator systems matching architectural design and operational needs."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://vastech.ae/elevator-solutions" />
      </Helmet>

      <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-accent/30">
        <Header />

        <main className="relative">
          {/* Enhanced Hero Section */}
          <ElevatorHero />

          {/* Introduction */}
          <ElevatorIntro />

          {/* Our Elevator Services */}
          <ElevatorServices />

          {/* Types of Elevators We Provide */}
          <ElevatorTypes />

          {/* Technology and Safety */}
          <TechAndSafety />

          {/* Expandable Design Options */}
          <ExpandableSolutions />

          {/* Start Your Elevator Project */}
          <ElevatorCTA />
        </main>

        {/* Minimalistic Footer (Consistent across pages) */}
        <Footer />
      </div>
    </>
  );
};

export default ElevatorSolutions;